import Const from 'constants';
import {combineReducers} from 'redux';

const defaultState = {
    data: {},
    has(combination) {
        return this.doIndex(combination) in this.data;
    },
    getValue(combination) {
        return this.data?.[this.doIndex(combination)]?.value ?? null;
    },
    all() {
        return cp(this.data);
    },
    doIndex(combination) {
        return combination.sort().join('');
    },
};

export function exposureMax(state = defaultState, action) {
    if (action.type === Const.SET_EXPOSURE_MAX_OF_TEAM_COMBINATIONS) {
        const {combo, value} = action.params;
        const data = cp(state.data);
        const index = state.doIndex(combo);
        data[index] = {
            uid: index,
            teamsCombination: [...combo],
            value,
        };

        state = {...state, data};
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {...defaultState};
    }

    return state;
}

const reducers = {
    exposureMax,
};

export default combineReducers(reducers);
